<template>
  <FormSubmitPopup :title="title" @popupClose="$emit('input', false)" v-model="value" ref="formPopup"
    :rightMethod="onSubmitted" :rightButtonText="$t('submit')" large>
    <template v-slot:input>
      <v-container>
        <v-card>
          <v-card-title>
            <h3>{{ $t('unitCLbHint') }}</h3>
          </v-card-title>

          <v-card-text class="pb-0">
            <v-list>
              <div v-for="(scope, index) in weightScope" :key="index">
                <v-list-tile-content>
                  <v-layout>
                    <v-text-field v-model.number="scope.start" :rules="[
                        getScopeValidator('start', weightScope, Number(index), 0)
                      ]" :disabled="index !== weightScope.length - 1" :label="`${$t('start')}('weight')`"
                      class="required_field"></v-text-field>
                    <v-flex pt-3 px-2><span>&lt; X ≤</span></v-flex>
                    <v-text-field style="width: 167px" v-model.number="scope.end" :rules="[
                        getScopeValidator('end', weightScope, Number(index), 1),
                      ]" name="end" :disabled="index !== weightScope.length - 1" class="required_field"
                      :label="`${$t('end')}('weight')`"></v-text-field>
                    <v-text-field v-model.number="scope.price" :label="$t('price')" prefix="$"
                      class="required_field pl-2"
                      :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"></v-text-field>
                      <v-text-field v-model.number="scope.secondItemPrice" :label="$t('secondItemPrice')" prefix="$"
                      class="required_field pl-2"
                      :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"></v-text-field>
                      <v-text-field v-if="feeType === 'outbound'" v-model.number="scope.secondProductPrice" :label="$t('subsequentUPCFirstPrice')" prefix="$"
                    class="required_field pl-2"
                    :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"></v-text-field>
                    <v-flex class="text-xs-right">
                      <v-btn @click="removeScope(index)" v-if="index === weightScope.length -1 && index > 0"
                        icon><v-icon>delete</v-icon></v-btn>
                    </v-flex>
                  </v-layout>
                </v-list-tile-content>
              </div>
              <v-layout v-if="weightScope.length > 0">
                <v-flex md4>
                  <v-text-field v-model.number="weightScope[weightScope.length - 1].overSizeChargePrice"
                  :label="$t('overSizeChargePrice')" prefix="$" class="required_field"
                  :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"></v-text-field>
                </v-flex>
              </v-layout>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-layout>
              <v-flex>
                <v-btn color="primary" @click="addScope(weightScope)">{{ $t('add') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-container>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import UploadFileWidget from './UploadFileWidget'
import { checkRules } from '@/utils/tools'

export default {
  name: 'InboundWeightFeeSettingPopup',
  components: { FormSubmitPopup, UploadFileWidget },
  mixins: [checkRules],
  data () {
    return {
      attachments: [],
      removeFilesUponUnmounted: true,
      weightScope: []
    }
  },
  mounted () {
    if (this.detail) {
      this.weightScope = this.detail.map((item) => {
        return {...item}
      })
      if (this.weightScope.length > 0) {
        this.weightScope[this.weightScope.length - 1].overSizeChargePrice = this.detail[this.detail.length - 1].overSizeChargePrice || 0
      }
    }
  },
  computed: {},
  methods: {
    getScopeValidator (field, that, index, scopeCode) {
      return (value) => {
        if (value === undefined || value === '') {
          return `${field}不能为空`
        }
        if (isNaN(value)) {
          return `${field}必须是数字`
        }
        if (value !== parseInt(value) && value !== Infinity) {
          return `${field}必须是整数`
        }
        const currentScope = that[index]
        if (scopeCode === 0 && index === 0 && value !== 0) {
          return '起始重量必须等于0'
        }

        if (scopeCode === 0 && currentScope.end <= value) {
          return '开始重量必须小于结束重量'
        }
        if (scopeCode === 1 && currentScope.start >= value) {
          return '结束重量必须大于开始重量'
        }

        if (index > 0 && scopeCode === 0 && that[index - 1].end !== value) {
          return '开始重量必须等于上一个范围的结束重量'
        }

        if (index < that.length - 1 && scopeCode === 1 && that[index + 1].start !== value) {
          return '结束重量必须等于下一个范围的开始重量'
        }
        
        return true
      }
    },

    addScope (current) {
      if (!this.$refs['formPopup'].validate()) return
      if (current?.length === 0) {
        current.push({ start: 0, end: 0, price: 0 })
      } else {
        const nextItem = current.at(-1)
        current.push({ start: nextItem.end, end: 0, price: 0 })
      }
      this.$nextTick(() => {
        const endInputs = document.querySelectorAll('input[name="end"]')
        if (endInputs.length === 0) return
        const lastEndInput = endInputs[endInputs.length - 1]
        if (lastEndInput) {
          lastEndInput.focus()
        }
      })
    },
    removeScope (index) {
      this.weightScope.splice(index, 1)
    },
    onSubmitted () {
      if (!this.$refs['formPopup'].validate()) return
      return this.submit(this.weightScope).catch(err => {
        this.$store.dispatch('showToast', {info: err.message, type: 'error'})
        throw err
      })
    }
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      default () {
        return this.$t('popup')
      }
    },
    detail: {
      type: Array,
      default () {
        return []
      }
    },
    submit: {
      type: Function,
      default () {
        return () => {}
      }
    },
    feeType: {
      type: String,
      default: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WeightFeeSettingPopup.vue